export default {"src":"/_next/static/image/public/images/flags/flag_598.a43539884326325e1e389cf11c869f9e.svg","height":16,"width":24};